import { Action } from '@ngrx/store';

export enum RmsModifyFlagTypes {
  RMS_MODIFY_FLAG = '[Rms Modify] flag',
  SCHEDULE_AVAILABLE_FLAG = '[Rms Modify] Schedule available flag',
  RESET = '[Rms Modify] Reset',
}

export class RmsModifyFlagAction implements Action {
  readonly type = RmsModifyFlagTypes.RMS_MODIFY_FLAG;

  constructor() {}
}

export class RmsAvailableScheduleModifyFlagAction implements Action {
  readonly type = RmsModifyFlagTypes.SCHEDULE_AVAILABLE_FLAG;

  constructor(public payload: any) {}
}

export class RmsModifyResetAction implements Action {
  readonly type = RmsModifyFlagTypes.RESET;

  constructor() {}
}

export type RmsModifyFlagActions = RmsModifyFlagAction | RmsModifyResetAction | RmsAvailableScheduleModifyFlagAction;
